export default __webpack_public_path__ + "static/media/problem-image.8a7b9fb2.png";